import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let form = useDataValue({
    context: 'form',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      next.id = form.id
      next.name = `${form.name}-${
        form.last_modified_by === 'None' ? 'New Form' : form.last_modified_by
      }`
      next.categories = form.categories
    })

    if (typeof props.closePopover === 'function') {
      props.closePopover()
    }
  }
}
